import { useQuery } from "@tanstack/react-query";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ChartAccountData } from "../types";
import withPrefix from "../../../helpers/useQueryPrefix";
import { fetchChartAccounts } from "../api/fetchChartAccounts";

export const useFetchChartAccounts = () => {
	return useQuery<ApiResponse<ChartAccountData[]>, Error, ChartAccountData[]>({
		queryKey: withPrefix(['chart_accounts']),
		queryFn: fetchChartAccounts,
		select: (response) => {
			if (response.status !== 200) {
				throw new Error(response.message);
			}
			return response.data as ChartAccountData[];
		},
	})
};
